<template>
	<ul class="nav navbar-nav ml-auto">
		<li class="nav-item dropdown mr-3">
			<a class="nav-link d-flex align-items-center" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false" data-test="userMenuToggle">
				<span class="d-sm-down-none">{{ user.first_name }}</span>
				<div class="rounded-circle circle-cropped avatar-md ml-2">
					<img :src="user.photo_url" class="img-fluid" :alt="user.display_name">
				</div>
			</a>
			<div class="drop-down dropdown-menu drop-down-show dropdown-menu-right mt-1 py-0">
				<div class="dropdown-header font-weight-bold">Account</div>
				<router-link class="dropdown-item" :to="{ name: 'tasks' }">
					<i class="fal fa-tasks"></i> Tasks
				</router-link>

				<router-link exact class="dropdown-item" :to="{ name: 'users.show', params: { 'id': user.id } }" data-test="userProfileLink">
					<i class="fal fa-user-circle"></i> Profile
				</router-link>

				<router-link exact class="dropdown-item" :to="{ name: 'users.edit', params: { 'id': user.id } }" data-test="userSettingsLink">
					<i class="fal fa-cog"></i> Settings
				</router-link>

				<div class="divider"></div>

				<a href="/logout" class="dropdown-item" onclick="event.preventDefault(); document.getElementById('logout-form').submit();">
					<i class="fal fa-sign-out"></i> Logout
				</a>
				<form id="logout-form" action="/logout" method="POST" style="display: none;">
					<input type="hidden" name="_token" :value="token">
				</form>

				<a v-if="user.is_impersonated" href="/impersonate/leave" class="dropdown-item bg-red-400 text-white">
					<i class="fal fa-mask text-white"></i> Un-impersonate
				</a>
			</div>
		</li>

		<li v-if="user.multi_client" class="nav-item dropdown mr-3" style="min-width: 0px; height: 32px; padding-top: 4px;">
			<a data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false" data-test="clientSwitcherToggle">
				<div class="rounded-circle circle-cropped avatar-sm text-center bg-gray-800">
					<i class="fal fa-hospital text-white"></i>
				</div>
			</a>
			<div class="dropdown-menu dropdown-menu-right py-0" data-test="clientSwitcher">
				<div class="dropdown-header font-weight-bold">Switch Client</div>
				
					<span v-if="client_list.length > 9" class="dropdown-item bg-gray-100">
						<input v-model="nameFilter" class="form-control form-control-sm" placeholder="Filter list">
						<span v-if="nameFilter" id="search_clear" @click.stop="resetFilter" data-test="filterClear">
							<i class="far fa-times-circle"></i>
						</span>
					</span>
					<span v-if="filteredClientClist.length == 0" class="dropdown-item text-gray-500">
						No matching clients
					</span>

					<div v-else id="clientList">
						<a v-for="client in filteredClientClist" href="#" class="dropdown-item d-flex align-items-center" @click="switchClient(client.id)">
							<span class="client-name flex-grow-1" :class="user.client_id === client.id ? 'active' : ''" v-html="client.name"></span>
							<i v-if="user.client_id === client.id" class="fas fa-check-circle text-primary ml-auto mr-0 pl-2" v-tooltip.bottom="'Current Client'"></i>
						</a>
					</div>
			</div>
		</li>
	</ul>
</template>

<script>


	import { mapGetters, mapState } from 'vuex';
	import PerfectScrollbar from 'perfect-scrollbar';


	export default {
		data() {
			return {
				token: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
				nameFilter: null,
				nameFilterDebounced: null,
			}
		},

		mounted() {
			const ps = new PerfectScrollbar('#clientList');
		},

		methods: {
			resetFilter() {
				this.nameFilter = null;
			},

        	switchClient(client_id) {
        		const currentUrl = this.$router.currentRoute.path.split('/');
        		axios.patch('/api/admin/users/switch-client', { client_id: client_id }).then(({ data }) => { 
                	Swal.fire({
                        toast: true,
						position: 'top-end',
						icon: 'success',
						title: 'Client switched! <br><br>Reloading...',
						showConfirmButton: false,
						timer: 1500
					});

					if (!this.$router.currentRoute.params.id || currentUrl[1] == 'admin'){
						//no client-specific stuff, just refresh the page
						window.location.reload();
					}
					else {
						//providers is the only place where there's no proper top-level page
						if (this.$router.currentRoute.name === 'physicians.show') {
							window.location.replace('/physicians/list');
						}
						if (this.$router.currentRoute.name === 'groups.show') {
							window.location.replace('/groups/list');
						}						
						else {
							window.location.replace(currentUrl.slice(0,2).join('/'));
						}
                    }

                    this.resetFilter();
            	});   
			},
		},

		computed: {
			...mapGetters(['client_list']),
			...mapState(['perms', 'user']),

			filteredClientClist() {
				return this.nameFilterDebounced ? this.client_list.filter(client => client.name.toLowerCase().includes(this.nameFilterDebounced)) : this.client_list;
			}
		},

		watch: {
			nameFilter: debounce(function (newVal) {
				this.nameFilterDebounced = newVal
			}, 400)
		}
	}
</script>

<style scoped>
	#clientList {
		position: relative;
		max-height: calc(100vh - 145px);
/*		max-height: 440px;*/
		overflow-x: hidden;
		overflow-y: hidden;		
		width: 17rem;
		min-width: 17rem;
	}

	#clientList .client-name {
		overflow: hidden;
    	text-overflow: ellipsis;
	}

	#search_clear {
		position: absolute;
	    top: 13px;
	    right: 15px;
	    z-index: 10;
	}
</style>